import React from 'react'
import {
  Edit,
  DisabledInput,
  TextInput,
  SimpleForm,
  EditButton,
  List,
  Datagrid,
  TextField,
  ReferenceInput,
  SelectInput,
  // CheckboxGroupInput,
  BooleanField,
  Filter,
  // ReferenceArrayField,
  // SingleFieldList,
  // ChipField,
} from 'admin-on-rest'
import BooleanInput from './components/BooleanInput';

const CountryFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Name" source="name" alwaysOn />
    <TextInput label="Сode" source="code" alwaysOn />
  </Filter>
)

const currencyOptionRenderer = (choice) => `${choice.symbol} ${choice.iso}`

export const CountryList = (props) => (
  <List {...props} sort={{ field: 'name', order: 'ASC' }} perPage={40} filters={<CountryFilter />}>
    <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
      <TextField label="Iso Code" source="code" />
      <TextField label="Country Name" source="name" />
      <TextField label="Currency" source="currency" />
      <BooleanField label="Overwrite Prices" source="priceOverwrite" />
      {/*<ReferenceArrayField label="Payment Methods" reference="paymentmethods" source="paymentMethods">*/}
      {/*  <SingleFieldList>*/}
      {/*    <ChipField source="name" />*/}
      {/*  </SingleFieldList>*/}
      {/*</ReferenceArrayField>*/}
      <EditButton />
    </Datagrid>
  </List>
)

const CountryTitle = ({ record }) => {
  return <span>Country {record ? `"${record.name}"` : ''}</span>
}

export const CountryEdit = (props) => (
  <Edit title={<CountryTitle />} {...props}>
    <SimpleForm>
      <DisabledInput source="id" />
      <DisabledInput label="ISO Code" source="code" />
      <DisabledInput label="Country Name" source="name" />
      <ReferenceInput
        label="Preferred Currency"
        source="currency"
        reference="currencies"
        allowEmpty
        sort={{ field: '_id', order: 'ASC' }}
        filter={{ inbound: true }}
        perPage={300}
        translate={(label) => label}
      >
        <SelectInput optionText={currencyOptionRenderer} optionValue="iso" translateChoice={false} />
      </ReferenceInput>
      <BooleanInput label="Overwrite Prices" source="priceOverwrite" />
      {/*<ReferenceInput*/}
      {/*  label="Payment Methods"*/}
      {/*  source="paymentMethods"*/}
      {/*  reference="paymentmethods"*/}
      {/*  allowEmpty*/}
      {/*  perPage={100}*/}
      {/*>*/}
      {/*  <CheckboxGroupInput optionText="name" optionValue="_id" translateChoice={false} />*/}
      {/*</ReferenceInput>*/}
    </SimpleForm>
  </Edit>
)



// WEBPACK FOOTER //
// ./src/countries.js